import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

const SummaryLine = ({ label, value }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: '160px 1fr', gap: 2 }}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 600 }}>
      {value || '—'}
    </Typography>
  </Box>
);

const ExportConfirmationDialog = ({
  open,
  loading,
  sourceProvider,
  discipline,
  selectedSeasons,
  startDate,
  endDate,
  competitions,
  onClose,
  onConfirm,
}) => {
  const seasonsLabel = selectedSeasons?.length
    ? selectedSeasons.join(', ')
    : 'Toutes les saisons';

  const temporalScopeLabel =
    !startDate && !endDate
      ? 'Aucune restriction de date'
      : `${startDate || 'Début non borné'} → ${endDate || 'Fin non bornée'}`;

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Confirmer l'export</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <SummaryLine label="Provider source" value={sourceProvider} />
          <SummaryLine label="Discipline" value={discipline} />
          <SummaryLine label="Saisons" value={seasonsLabel} />

          <Divider />

          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Compétitions sélectionnées
            </Typography>
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
              {competitions.map((competition) => (
                <Chip
                  key={competition._id}
                  label={`${competition.name}${competition.season ? ` — ${competition.season}` : ''}`}
                  variant="outlined"
                />
              ))}
            </Stack>
          </Box>

          <Divider />

          <SummaryLine label="Périmètre temporel" value={temporalScopeLabel} />
          <SummaryLine
            label="Règle joueurs"
            value="Player.teamsSeason fait foi ; Player.teams est reconstruit depuis les périodes retenues"
          />
          <SummaryLine
            label="Données incluses"
            value="Compétitions, équipes, joueurs, matchs et faits de jeu"
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Modifier
        </Button>
        <Button onClick={onConfirm} variant="contained" disabled={loading}>
          {loading ? 'Préparation...' : 'Confirmer'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportConfirmationDialog;
